import React from 'react';
import { motion } from 'framer-motion';
import ChatBubbleIcon from './icons/ChatBubbleIcon';

export default function ChatBubble({ chatButtonImage, primaryColor, textColor }) {
  const chatButton = () => {
    return <ChatBubbleIcon className="w-10" alt="Livechat" color={textColor.hex} />;
  };

  return (
    <motion.button
      className={`${textColor.token} trigger-button w-16 h-16 cursor-pointer justify-center items-center flex hover:opacity-80 rounded-full`}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      style={{
        backgroundImage: `url(${chatButtonImage})`,
        backgroundSize: 'cover',
        backgroundColor: primaryColor || 'bg-callbell-green'
      }}
    >
      {!chatButtonImage && chatButton()}
    </motion.button>
  );
}
